import { useMutation } from "@tanstack/react-query";

import { upgradeSubscriptionService } from "../services/subscriptions";

export const useUpgradeSubscription = (onSuccess?: (data: any, subscriptionPlanId: number) => void) => {
  return useMutation({
    mutationFn: (subscriptionPlanId: number) => upgradeSubscriptionService(subscriptionPlanId),
    onSuccess: (data, subscriptionPlanId) => {
      if (onSuccess) onSuccess(data, subscriptionPlanId);
    },
  });
};
